// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"AppBar_searchBar__331uJ"};